// extracted by mini-css-extract-plugin
export default {"deleteBtn":"PayrollModal_deleteBtn__oymcn"};